module.exports = __webpack_public_path__ + "img/flying-disc.96c9df48.png";